import { Injectable } from '@angular/core';
import {AbstractSessionParametersUpdaterService} from '../../services/abstract-session-parameters-updater-service';
import {VATParameters} from '../../services/vat/vat-parameters';

@Injectable({
  providedIn: 'root'
})
export class VatParametersUpdaterService extends AbstractSessionParametersUpdaterService<VATParameters>{

  constructor() {
      super('VAT');
  }
}
